import { xavis_experiments } from '../../y/debug';
import { $el } from '../elements';
import { uiHidePopup, uiShowPopup, UIPopupOptions } from '../popup';
import { onHover } from '../touch';
import { UIClassesSpec, UIPoint, UIRelPos } from '../types';
import { UIView, UIViewAddSpec, UIViewSpec } from '../view';

export interface UITooltipOptions {
    kind?: 'k-chart' | 'k-default' | 'k-table';
    inside?: UIViewSpec;
    hover?: UIViewSpec;
    click?: UIViewSpec;
    classes?: UIClassesSpec;
}

export class UITooltip extends UIView {
    private _content: HTMLElement;
    private _inside?: UIViewSpec;

    constructor(content: UIViewAddSpec, options: UITooltipOptions = {}) {
        super('div', ['ui-tooltip', options.kind || 'k-default', options.classes]);
        this._inside = options.inside
        this.ui_add([$el.DIV('r-arrow'), this._content = $el.SPAN('r-content', content)]);
    }

    set content(content: UIViewAddSpec) {
        this._content.ui_empty(content)
    }

    set text(text: string) {
        this._content.textContent = text;
    }

    place(point: UIPoint, position: UIRelPos = UIRelPos.Below) {
        if(!this._inside)
            throw new Error("Can't place tooltip without a reference");

        this.ui_show();
        uiShowPopup(this, this._inside, { position: position, anchor: point, context: this._inside });
    }
}

let _current_tooltip: UITooltip | undefined;

export function addTooltip(content: UIViewAddSpec | (() => UIViewAddSpec | undefined), ref: UIViewSpec, options: UIPopupOptions & UITooltipOptions) {
    if(xavis_experiments && options.kind !== 'k-table')
        options.animate = true;

    if(options.hover || !options.click) {
        onHover(options.hover || ref, e => {
            if(e.hover)
                showTooltip(typeof content == 'function' ? content() : content, ref, options);
            else
                hideTooltip();
        });
    }

    if(options.click) {
        let shown = false;
        const elem = options.click.ui_elem;
        elem.addEventListener('click', e => {
            if(!shown) {
                showTooltip(typeof content == 'function' ? content() : content, ref, options);
                shown = true;
            }
            const doc_handler = (e: Event) => {
                if(shown) {
                    const elem = e.target as HTMLElement;
                    if(elem.closest('.ui-tooltip'))
                        return;

                    hideTooltip();
                    shown = false;
                }
                document.removeEventListener('mousedown', doc_handler);
                document.removeEventListener('touchstart', doc_handler);
            }
            document.addEventListener('mousedown', doc_handler);
            document.addEventListener('touchstart', doc_handler);
            e.stopPropagation();
        });
    }
}

export function showTooltip(content: UIViewAddSpec | undefined, ref: UIViewSpec, options: UIPopupOptions & UITooltipOptions) {
    _current_tooltip && uiHidePopup(_current_tooltip);
    if(content) {
        const tooltip = new UITooltip(content, options);
        uiShowPopup(tooltip, ref, options);
        _current_tooltip = tooltip;
    } else {
        _current_tooltip = undefined;
    }
}

export function hideTooltip() {
    _current_tooltip && uiHidePopup(_current_tooltip);
    _current_tooltip = undefined;
}
